// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"3d2fcf20","418":"20638035","778":"90dd33e0"}[chunkId] + ".chunk.css";
};